module.exports = __webpack_public_path__ + "img/empty.31566d92.png";